// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type EyeShowSvgrepoComsvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function EyeShowSvgrepoComsvgIcon(props: EyeShowSvgrepoComsvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      preserveAspectRatio={"xMidYMid meet"}
      viewBox={"0 0 36 36"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M33.62 17.53c-3.37-6.23-9.28-10-15.82-10S5.34 11.3 2 17.53l-.28.47.26.48c3.37 6.23 9.28 10 15.82 10s12.46-3.72 15.82-10l.26-.48zm-15.82 8.9C12.17 26.43 7 23.29 4 18c3-5.29 8.17-8.43 13.8-8.43S28.54 12.72 31.59 18c-3.05 5.29-8.17 8.43-13.79 8.43z"
        }
        className={"clr-i-outline clr-i-outline-path-1"}
      ></path>

      <path
        d={
          "M18.09 11.17A6.86 6.86 0 1025 18a6.86 6.86 0 00-6.91-6.83zm0 11.72A4.86 4.86 0 1123 18a4.87 4.87 0 01-4.91 4.89z"
        }
        className={"clr-i-outline clr-i-outline-path-2"}
      ></path>

      <path fill={"none"} d={"M0 0h36v36H0z"}></path>
    </svg>
  );
}

export default EyeShowSvgrepoComsvgIcon;
/* prettier-ignore-end */
